import { Award, MapPin, Languages, Target } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = [Award, MapPin, Languages, Target];

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section className="section-pad bg-cb-accent-surface">
      <div className="container-cb grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="overline mb-4 flex items-center gap-3"><span className="gold-divider" /> {t.why.overline}</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-cb-primary">{t.why.title}</h2>
        </div>
        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
          {t.why.items.map((w, i) => {
            const Icon = ICONS[i] || Award;
            return (
              <div key={i} className="card-cb p-6" data-testid={`why-card-${i}`}>
                <div className="w-11 h-11 rounded-lg bg-cb-gold/15 text-cb-emerald grid place-items-center">
                  <Icon size={20} />
                </div>
                <h3 className="mt-4 text-lg font-semibold text-cb-primary" style={{ fontFamily: "Outfit" }}>{w.t}</h3>
                <p className="mt-2 text-sm text-cb-secondary leading-relaxed">{w.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
